import { dateString, dateStringParts } from './dateString.js';
import { allPayments, categoriseAmount, literalStart, repeat, scaleAmount, unit, } from './payments/payments.js';
export const RUN_RATE_SCHEDULE_TYPE = 'run_rate';
export const RUN_RATE_FORECAST_YEARS = 5;
export const EXPENSE_INFLATION_PERCENT_RANGE = { min: 0, max: 15 };
export const DEFAULT_EXPENSE_INFLATION_PERCENT = 3;
export function escalatedMonthlyAmounts(monthlyAmount, inflationPercent) {
    const growth = 1 + inflationPercent / 100;
    return Array.from({ length: RUN_RATE_FORECAST_YEARS + 1 }, (_, yearOffset) => monthlyAmount * growth ** yearOffset);
}
export function runRateForecastEnd(today) {
    return dateString(`${dateStringParts(today).year + RUN_RATE_FORECAST_YEARS}-12-31`);
}
export function runRateForecastStart(today) {
    const { year, month } = dateStringParts(today);
    return dateString(`${year}-${String(month).padStart(2, '0')}-01`);
}
function monthlyFrom(taxonomy, description, amount, start, end) {
    return repeat({ kind: 'monthly', dayOfMonth: 1, interval: 1 }, categoriseAmount(taxonomy, description, scaleAmount(amount, unit())), 'USD', start, end);
}
export function runRateForecastTerm(taxonomy, description, monthlyAmount, inflationPercent, today) {
    const { year } = dateStringParts(today);
    const amounts = escalatedMonthlyAmounts(monthlyAmount, inflationPercent);
    return allPayments(...amounts.map((amount, yearOffset) => monthlyFrom(taxonomy, description, amount, yearOffset === 0 ? runRateForecastStart(today) : dateString(`${year + yearOffset}-01-01`), dateString(`${year + yearOffset}-12-31`))));
}
function runRateYearOf(payment) {
    if (payment.kind !== 'repeat' || payment.endDate === undefined)
        return null;
    const start = literalStart(payment);
    if (start === undefined)
        return null;
    const described = payment.amount;
    if (described.kind !== 'describe' || described.classification?.kind !== 'taxonomy')
        return null;
    const scaled = described.amount;
    if (scaled.kind !== 'scale' || scaled.factor.kind !== 'const')
        return null;
    const { category, subcategory } = described.classification;
    return {
        taxonomy: { category, subcategory },
        description: described.description,
        amount: scaled.factor.value,
        start,
        end: payment.endDate,
    };
}
function runRateYearsOf(payment) {
    const parts = payment.kind === 'all' ? payment.payments : [payment];
    const years = parts.map(runRateYearOf);
    return years.every((year) => year !== null) && years.length > 0 ? years : null;
}
export function runRateBaseOf(payment) {
    return runRateYearsOf(payment)?.[0]?.amount ?? null;
}
export function withInflationPercent(payment, inflationPercent) {
    const years = runRateYearsOf(payment);
    const base = years?.[0];
    if (years === null || base === undefined)
        return null;
    const growth = 1 + inflationPercent / 100;
    return allPayments(...years.map((year, yearOffset) => monthlyFrom(year.taxonomy, year.description, base.amount * growth ** yearOffset, year.start, year.end)));
}
//# sourceMappingURL=expenseForecast.js.map